export const SAVE_USER_ID = './save_user_id'

export const SET_LISTS = './set_lists'
